import { render } from "./LabelComponent.vue?vue&type=template&id=3eb0db24"
import script from "./LabelComponent.vue?vue&type=script&lang=js"
export * from "./LabelComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__